<template>
    <div>
        <h2 class="mt-6 text-3xl leading-9 font-extrabold text-gray-900">
            {{ $t('auth.newPassword.pageTitle') }}
        </h2>

        <p class="mt-6 flex flex-col items-center justify-between text-sm leading-5">
            {{ $t('auth.newPassword.instructions') }}
        </p>

        <div class="mt-8">
            <form class="mt-6" @submit="resetPassword">
                <apexo-input-group :label="$t('auth.login.email')">
                    <apexo-input
                        label="Adresse courriel"
                        name="email"
                        type="email"
                        v-model="email"
                    />
                </apexo-input-group>
                <apexo-input-group class="mt-5" :label="$t('auth.newPassword.password')">
                    <apexo-input
                        label="Mot de passe"
                        name="password"
                        type="password"
                        v-model="password"
                    />
                </apexo-input-group>
                <apexo-input-group class="mt-5" :label="$t('auth.newPassword.passwordConfirmation')">
                    <apexo-input
                        label="Confirmation du mot de passe"
                        name="passwordConfirmation"
                        type="password"
                        v-model="password_confirmation"
                    />
                </apexo-input-group>

                <apexo-button
                    class="mt-6"
                    :disabled="!valid"
                    @click="resetPassword"
                >
                    {{ $t('auth.newPassword.changePassword') }}
                </apexo-button>
            </form>
        </div>

        <div class="mt-6 flex flex-col items-center justify-between text-sm leading-5 text-center">
            <p>
                {{ $t('auth.forgotPassword.passwordFound') }}
            </p>

            <router-link
                class="font-medium text-green-600 hover:text-green-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                :to="{ name: 'auth.login' }"
            >
                {{ $t('auth.login.connect') }}
            </router-link>
        </div>
    </div>
</template>

<script>
    import ApexoButton from '@/components/Elements/ApexoButton.vue';
    import ApexoInput from '@/components/Elements/ApexoInput.vue';
    import ApexoInputGroup from '@/components/Elements/ApexoInputGroup';

    export default {
        name: 'ChangePassword',

        components: {
            ApexoInputGroup,
            ApexoButton,
            ApexoInput,
        },

        data() {
            return {
                email: '',
                password_confirmation: '',
                password: '',
                token: '',
            };
        },

        computed: {
            valid() {
                return this.password_confirmation && this.password && this.email && this.password === this.password_confirmation;
            },
        },

        methods: {
            async resetPassword() {
                if (this.valid) {
                    try {
                        await this.$axios.post('/password/reset', {
                            email: this.email,
                            password: this.password,
                            password_confirmation: this.password_confirmation,
                            token: this.token,
                        });

                        await this.$router.push('/login');
                    } catch (error) {
                        console.log(error);
                    }
                }
            },
        },

        mounted() {
            this.token = this.$route.params.token;
        },
    };
</script>
